export default __webpack_public_path__ + "static/media/generate.be4221a0.png";